import React, { Component } from "react";
import dayjs from "dayjs";
import { MessageType } from "./Message";

class LocationMessage extends Component {

    render() {
        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                    <a href={this.getMapLinkURL()} target="_blank">
                        <img src={this.getStaticMapURL()} width="100%" height="100%" alt="Map"/>
                        <br />
                    </a>
                </div>
                {this.showMessageTime() && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(Math.trunc(this.props.message.message.sentTimestamp/1000)).format("h:mm a")}</div>}
            </div>
        )
    }

    googleMapsAPIKey = "AIzaSyBSUwGhZOqKroutZ0dSV_JwELEfp2oO2yI";
    getStaticMapURL = () => {
        return "https://maps.googleapis.com/maps/api/staticmap?center=" + this.props.message.message.text + "&zoom=12&size=400x400&maptype=roadmap&format=png&visual_refresh=true&key=" + this.googleMapsAPIKey;
    }

    getMapLinkURL = () => {
        return "http://www.google.com/maps/place/" + this.props.message.message.text;
    }

    showMessageTime = () => {
        return (this.props.message.type !== MessageType.info);
    }

    messageTimeClassName = () => {
        switch (this.props.message.type) {
            case MessageType.sent: return "s360-message-time-sent";
            case MessageType.received: return "s360-message-time-received";
            case MessageType.info: return "s360-message-time-info";
            default: return "";
        }
    }

    messageBoxClassName = () => {
        switch (this.props.message.type) {
            case MessageType.sent: return "s360-message-box-sent";
            case MessageType.received: return "s360-message-box-received";
            case MessageType.info: return "s360-message-box-info";
            default: return "";
        }
    }

    messageContainerClassName = () => {
        switch (this.props.message.type) {
            case MessageType.sent: return "s360-message-cotainer-sent";
            case MessageType.received: return "s360-message-cotainer-received";
            case MessageType.info: return "s360-message-cotainer-info";
            default: return "";
        }
    }

    messageBoxStyle = () => {
        let config = this.props.config;
        switch (this.props.message.type) {
            case MessageType.received: return { height:"105px", background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.SenderMessageFont, fontSize: config.designDetails.SenderMessageFontSize, color: config.designDetails.senderMessageFontColor }
            case MessageType.sent: return { height:"105px", background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.ReceiverMessageFont, fontSize: config.designDetails.ReceiverMessageFontSize, color: config.designDetails.recieverMessageFontColor }
            default: return {}
        }
    }

    messageContainerStyle = () => {
        // let config = this.props.config
        return {}
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        switch (this.props.message.type) {
            case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor }
            case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor }
            case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageTimeFontColor }
            default: return {}
        }
    }

}

export default LocationMessage;
